import { TextLabel } from '../TextLabel';
import { StyledContainer } from './Popup.styled';

interface IPopupProps extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	className?: string;
}

const Popup: React.FC<IPopupProps> = ({ text, className }: IPopupProps) => {
	return (
		<StyledContainer className={className}>
			<TextLabel
				style={{ color: '#000000', fontSize: '14px', fontWeight: 400 }}
			>
				{text}
			</TextLabel>
		</StyledContainer>
	);
};

export { Popup };
